module.exports = __webpack_public_path__ + "static/cto-e0e2c75ee8b5b07fb2835123f50953ec.png";